// topFoldersService.js
export const fetchTopFolders = async ({
                                          selectedProjectId,
                                          selectedHubId,
                                          accessToken,
                                      }) => {
    console.log('fetchTopFolders called with:', {
        selectedProjectId,
        selectedHubId,
        accessToken: accessToken ? 'present' : 'missing',
    });
    
    console.log('Project ID details:', {
        value: selectedProjectId,
        type: typeof selectedProjectId,
        length: selectedProjectId?.length,
        isString: typeof selectedProjectId === 'string',
        isEmpty: selectedProjectId === '',
        isNull: selectedProjectId === null,
        isUndefined: selectedProjectId === undefined
    });

    const response = await fetch(
        `https://developer.api.autodesk.com/project/v1/hubs/${selectedHubId}/projects/${selectedProjectId}/topFolders`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );

    if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Error fetching top folders: ${errorMessage}`);
    }

    const data = await response.json();
    console.log('fetchTopFolders response:', data);
    return data;
};
